import Experience from '../Experience.js'
import Environment from './Environment.js'
import LuxurySphere from './Spheres/LuxurySphere.js'
import SimpleSphere from './Spheres/SimpleSphere.js'
import Rings from './Rings.js'
import Text from './Text.js'

export default class World {
    constructor(interactive) {
        this.experience = new Experience()
        this.tasteLabels = this.experience.tasteLabels
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.gui = this.experience.debug.ui
        this.groupOffset = 3.99
        this.resources.on('ready', () => {
            this.environment = new Environment()


            const font = this.resources.items.font
            if (font) {
                this.setupLoremTexts()
            }

            //    this.simpleSphere = new SimpleSphere(this.scene, this.gui, this.experience.debug.active)

            this.luxurySphere = new LuxurySphere(interactive)
        })
    }
    setupLoremTexts() {
        const font = this.resources.items.font // Replace 'font' with your actual font resource name

        if (!font) {
            console.error('Font not loaded!')
            return
        }

        this.salty = new Text(this.tasteLabels.salzig || 'Salzig', this.scene, font, true, this.groupOffset)
        this.salty.textGroup.position.set(0, this.groupOffset * 2, 0)
        this.sour = new Text(this.tasteLabels.sauer || 'Sauer', this.scene, font, true, this.groupOffset)
        this.sour.textGroup.position.set(-this.groupOffset, this.groupOffset, 0)
        this.sour.textGroup.rotation.z = Math.PI / 2

        this.sweet = new Text(this.tasteLabels.suess || 'Süß', this.scene, font, true, this.groupOffset)
        this.sweet.textGroup.position.set(this.groupOffset, this.groupOffset, 0)
        this.sweet.textGroup.rotation.z = -Math.PI / 2

        this.spicy = new Text(this.tasteLabels.scharf || 'Scharf', this.scene, font, false, this.groupOffset)
        this.spicy.textGroup.position.set(0, 0.0, 0)


        this.umami = new Text(this.tasteLabels.umami || 'Umami', this.scene, font, false, this.groupOffset)
        this.umami.textGroup.position.set(0, this.groupOffset + 0.2, 1)

        this.texts = [
            this.salty,
            this.sour,
            this.sweet,
            this.spicy,
            this.umami
        ]
    }

    update() {
        if (this.simpleSphere) this.simpleSphere.update()
        if (this.rings) this.rings.update()
        if (this.loremText) this.loremText.update()
        if (this.luxurySphere) this.luxurySphere.update()
    }
}